
export default function Features() {
  const features = [
    {
      title: 'Advanced Encryption',
      description: 'Military-grade encryption protocols to protect your data',
      image: 'https://public.readdy.ai/ai/img_res/5c12425d10b889d26ef7466b7324b0cc.jpg',
      icon: 'ri-lock-line'
    },
    {
      title: 'Fast Performance',
      description: 'Optimized algorithms for lightning-fast cleaning and connection',
      image: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20illustration%20showing%20speed%20and%20performance%20with%20dynamic%20motion%20lines%20and%20gradient%20colors%20in%20blue%20and%20purple%20tones%2C%20minimalist%20design%20representing%20fast%20processing%20and%20optimization%20for%20mobile%20iOS%20application%20with%20clean%20contemporary%20aesthetic&width=400&height=400&seq=feature-performance-002&orientation=squarish',
      icon: 'ri-speed-line'
    },
    {
      title: 'Privacy Protection',
      description: 'No logs policy ensuring complete anonymity and privacy',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20privacy%20and%20anonymity%20with%20shield%20and%20eye%20symbols%20in%20teal%20and%20green%20gradient%20colors%2C%20clean%20professional%20design%20showing%20data%20protection%20and%20confidentiality%20concept%20for%20iOS%20security%20application%20with%20modern%20geometric%20patterns&width=400&height=400&seq=feature-privacy-003&orientation=squarish',
      icon: 'ri-eye-off-line'
    },
    {
      title: 'Easy to Use',
      description: 'Intuitive interface designed for seamless user experience',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20illustration%20of%20user%20interface%20and%20usability%20with%20simple%20geometric%20shapes%20and%20icons%20in%20soft%20blue%20and%20white%20gradient%20colors%2C%20modern%20design%20representing%20intuitive%20navigation%20and%20ease%20of%20use%20for%20iOS%20mobile%20application%20with%20contemporary%20aesthetic&width=400&height=400&seq=feature-usability-004&orientation=squarish',
      icon: 'ri-hand-heart-line'
    }
  ];

  return (
    <div className="bg-slate-900 py-32">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="flex items-start justify-between mb-20">
          <div>
            <div className="inline-block px-4 py-2 border border-white/30 rounded-full mb-8">
              <span className="text-xs font-semibold text-white tracking-wider uppercase">
                Features
              </span>
            </div>
            <h3 className="text-6xl font-bold text-white leading-tight max-w-2xl">
              Enhanced Security<br />& Performance
            </h3>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-stone-50 rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow">
              <div className="w-full h-64">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="bg-gray-900 p-8">
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center mr-3">
                    <i className={`${feature.icon} text-xl text-white`}></i>
                  </div>
                  <h4 className="text-xl font-bold text-white">{feature.title}</h4>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
